import { LOGGER_PREFIX } from './constants'

/**
 * postmessage通信
 */
export default class PM {
  private target: Window
  private clazz: string
  private origin: string
  private listeners: {
    // key is event type
    [key: string]: EventObj[]
  } = {}

  constructor(options: PMOptions) {
    const { target, clazz = 'default', origin = '*' } = options
    this.target = target
    this.clazz = clazz
    this.origin = origin

    if (window.addEventListener) {
      window.addEventListener('message', this.handler.bind(this), false)
    } else {
      // @ts-ignore
      window.attachEvent('onmessage', this.handler.bind(this))
    }
  }

  public on(cmd: string, handler: Handler, scope: any = window): PM {
    const { listeners, clazz } = this
    listeners[cmd] = listeners[cmd] = []
    listeners[cmd].push({
      scope,
      clazz,
      handler
    })
    console.log(
      `[${LOGGER_PREFIX}] add event listeners cmd '${cmd}'`,
      this.listeners
    )
    return this
  }

  public emit(cmd: string, data: any = ''): PM {
    const { origin } = this
    console.log(
      `[${LOGGER_PREFIX}] emit postmessage cmd '${cmd}', data is`,
      data
    )
    this.target.postMessage(
      {
        cmd,
        data
      },
      origin
    )
    return this
  }

  public remove(cmd: string, handler: Handler, scope: any = window): PM {
    const exactListeners = this.listeners[cmd]

    if (exactListeners && exactListeners.length > 0) {
      const exactlistenersAfter: EventObj[] = []
      exactListeners.forEach(listener => {
        if (listener.scope !== scope || listener.handler !== handler) {
          exactlistenersAfter.push(listener)
        }
      })

      this.listeners[cmd] = exactlistenersAfter
    }

    console.log(
      `[${LOGGER_PREFIX}] remove event listeners cmd '${cmd}'`,
      this.listeners
    )

    return this
  }

  public removeAll(cmd: string): PM {
    delete this.listeners[cmd]
    return this
  }

  public hasEventListener(
    cmd: string,
    handler: Handler,
    scope: any = window
  ): boolean {
    const exactListeners = this.listeners[cmd]

    if (!exactListeners) {
      return false
    }

    let result = false
    exactListeners.forEach(listener => {
      if (listener.scope === scope && listener.handler === handler) {
        result = true
      }
    })
    return result
  }

  private handler(event: MessageEvent) {
    console.log(`[${LOGGER_PREFIX}] ready to handle postmessage event`, event)
    if (!this.isEventAvailable(event)) {
      return
    }

    const { listeners } = this
    const { cmd, ...rest } = event.data
    console.log(`[${LOGGER_PREFIX}] event info cmd '${cmd}', data`, rest)
    const exactListeners = listeners[cmd]
    if (exactListeners) {
      exactListeners.slice().forEach(listener => {
        const { scope, handler } = listener
        console.log(`[${LOGGER_PREFIX}] handle call data is`, rest)
        handler.call(scope, rest)
      })
    }
  }

  private isEventAvailable(event: MessageEvent): boolean {
    const { data = {} } = event
    const { cmd, clazz = 'default' } = data
    return cmd && clazz === this.clazz
  }
}

export interface PMOptions {
  target: Window
  // 场景：当一个父级页面以iframe加载了两个相同的子页面时，可以根据这个clazz来隔离两个子页面与父页面的通信
  clazz?: string
  origin?: string
}

interface EventObj {
  // 回调的上下文
  scope: any
  clazz: string
  handler: Handler
}
type Handler = (payload: any) => void
